import { apiClient } from '../../apiClient';

export const shopService = {
  getAllShops: () => apiClient.get('/shops'),
  getShopsByOwner: (ownerId) => apiClient.get(`/shops/owner/${ownerId}`),
  getShopById: (id) => apiClient.get(`/shops/${id}`),
  getVerifiedShops: () => apiClient.get('/shops/verified'),
  getNearbyShops: (params) => {
    const searchParams = new URLSearchParams();
    if (params?.lat != null) searchParams.append('lat', params.lat);
    if (params?.lng != null) searchParams.append('lng', params.lng);
    searchParams.append('radius', params?.radius ?? 10);
    searchParams.append('sort', params?.sort ?? 'distance');
    if (params?.minRating != null) searchParams.append('minRating', params.minRating);
    if (params?.maxPrice != null) searchParams.append('maxPrice', params.maxPrice);
    return apiClient.get(`/shops/nearby?${searchParams}`);
  },
  createShop: (data) => apiClient.post('/shops', data),
  updateShop: (id, data) => apiClient.put(`/shops/${id}`, data),
  verifyShop: (shopId) => apiClient.patch(`/shops/${shopId}/verify`),
};
